import { render, staticRenderFns } from "./pedidosDocsAdd.vue?vue&type=template&id=ff3ea9ca&"
import script from "./pedidosDocsAdd.vue?vue&type=script&lang=js&"
export * from "./pedidosDocsAdd.vue?vue&type=script&lang=js&"
import style0 from "./pedidosDocsAdd.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports